import { Directive, inject, TemplateRef } from '@angular/core';

/**
 * Marks the content of the dialog's «Dokumenten-Manager» segment, a consumer's picker of existing
 * documents. Rendered only while that segment is active.
 *
 * Place it as an `<ng-template lpDokumentUploadPick>` inside `lp-dokument-upload-modal`.
 */
@Directive({ selector: 'ng-template[lpDokumentUploadPick]' })
export class DokumentUploadPickDirective {
  public readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);
}
